<template>
  <div>
    <polymorphic-reference-create
      :ams_template="ams_template"
      :reroute="reroute"
    ></polymorphic-reference-create>
  </div>
</template>

<script>
import PolymorphicReferenceCreate from './PolymorphicReferenceCreate.vue'

export default {
  components: {
    PolymorphicReferenceCreate
  },
  props: {
    reroute: {
      Type: Boolean,
      default: true
    },
    ams_template: {
      Type: Object
    }
  }
}
</script>